<template>
    <v-card>
        <v-snackbar dense v-model="$root.notificacion.mostrarALerta" :color="$root.notificacion.bg"
            :right="$root.isTouch == false" :timeout="timeout" :multi-line="$root.isTouch" :top="$root.isTouch">
                <v-icon :large="$root.isTouch == false" :small="$root.isTouch"
                        :color="$root.notificacion.color">{{ $root.notificacion.icono }}
                </v-icon>
            <span class="ml-2 body-1">{{ $root.notificacion.mensaje }}</span>
            
            <v-btn x-small dark :color="$root.notificacion.color"  @click="$root.notificacion.mostrarALerta = false" v-html="'Cerrar'" />
        </v-snackbar>
    </v-card>
</template>

<script>
    export default {
        data() {
            return {
                timeout: 6000,
                obj: {}
            }
        },
        created() {
            this.obj = this.$root.notificacion;
        }
    }
</script>